/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoCreateFlightCompany } from '../../models/dto-create-flight-company';
import { FlightCompany } from '../../models/flight-company';

export interface CommonControllerCreateFlightCompany$Params {
      body: DtoCreateFlightCompany
}

export function commonControllerCreateFlightCompany(http: HttpClient, rootUrl: string, params: CommonControllerCreateFlightCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerCreateFlightCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: FlightCompany;
      }>;
    })
  );
}

commonControllerCreateFlightCompany.PATH = '/common/flight-companies';
